// import buttonFormFields from '@/components/sections/form-fields/content/button'
import sectionFormFields from '@/components/sections/form-fields/design/section'
import contentBoxFormFields from '@/components/sections/form-fields/layout/category-content-box'
import structureFormFields from '@/components/sections/form-fields/layout/structure'

export const content = {
  title: {
    label: 'Title',
    type: 'text'
  },

  'content-subtitle': {
    label: 'Subtitle',
    type: 'text',
    category: 'Left column - Content'
  },
  'content-text': {
    label: 'Text',
    type: 'text-editor',
    category: 'Left column - Content'
  },

  'menu-subtitle': {
    label: 'Subtitle',
    type: 'text',
    category: 'Center column - Menu'
  },
  menu: {
    label: 'Menu',
    type: 'menu-select',
    hint:
      'Use default to display a menu based on visible pages. You may also select custom menus that you have added through the "Pages & Navigation" panel.',
    category: 'Center column - Menu'
  },

  'social-media-subtitle': {
    label: 'Subtitle',
    type: 'text',
    category: 'Right column - Social media'
  },
  'social-media': {
    label: 'Social media',
    type: 'repeatable',
    fields: {
      'social-media-label': {
        label: 'Social media label',
        type: 'text',
        rules: ['required']
      },
      'social-media-link': {
        label: 'Social media link',
        type: 'text',
        rules: ['required'],
        hideOnList: true
      },
      'social-media-icon': {
        label: 'Social media icon',
        type: 'select',
        rules: ['required'],
        options: [
          { value: 'facebook', text: 'Facebook' },
          { value: 'facebook-messanger', text: 'Facebook Messenger' },
          { value: 'twitter', text: 'Twitter' },
          { value: 'linkedin', text: 'Linkedin' },
          { value: 'instagram', text: 'Instagram' },
          { value: 'google-plus', text: 'Google Plus' },
          { value: 'youtube', text: 'Youtube' },
          { value: 'email', text: 'Email' },
          { value: 'snapchat', text: 'Snapchat' }
        ]
      }
    },
    category: 'Right column - Social media'
  }
}

export const design = {
  ...sectionFormFields,
  'title-color': {
    label: 'Title color',
    type: 'text-color',
    category: 'Text'
  },
  'title-font-weight': {
    label: 'Title font weight',
    type: 'radio',
    options: [
      { value: 'var(--title-font-weight)', text: 'Default' },
      { value: 'lighter', text: 'Light' },
      { value: 'bold', text: 'Bold' }
    ],
    category: 'Text'
  },
  'title-tag': {
    label: 'Title header type',
    type: 'radio',
    options: [
      { value: 'h1', text: 'Heading 1' },
      { value: 'h2', text: 'Heading 2' },
      { value: 'h3', text: 'Heading 3' },
      { value: 'h4', text: 'Heading 4' },
      { value: 'h5', text: 'Heading 5' },
      { value: 'h6', text: 'Heading 6' }
    ],
    category: 'Text'
  },

  'subtitle-color': {
    label: 'Subtitle color',
    type: 'text-color',
    category: 'Text'
  },
  'subtitle-font-weight': {
    label: 'Subtitle font weight',
    type: 'radio',
    options: [
      { value: 'var(--title-font-weight)', text: 'Default' },
      { value: 'lighter', text: 'Light' },
      { value: 'bold', text: 'Bold' }
    ],
    category: 'Text'
  },
  'subtitle-tag': {
    label: 'Subtitle header type',
    type: 'radio',
    options: [
      { value: 'h1', text: 'Heading 1' },
      { value: 'h2', text: 'Heading 2' },
      { value: 'h3', text: 'Heading 3' },
      { value: 'h4', text: 'Heading 4' },
      { value: 'h5', text: 'Heading 5' },
      { value: 'h6', text: 'Heading 6' }
    ],
    category: 'Text'
  },

  'text-color': {
    label: 'Text color',
    type: 'text-color',
    category: 'Text'
  }
}

export const layout = {
  ...structureFormFields,
  ...contentBoxFormFields
}

export const advanced = {
  'active-style': {
    label: 'Style for active and hover',
    type: 'select',
    options: [
      { value: 'default', text: 'Default' },
      { value: 'none', text: 'None' },
      { value: 'bold', text: 'Bold' },
      { value: 'color-primary', text: 'Color (Primary)' },
      { value: 'color-secondary', text: 'Color (Secondary)' },
      { value: 'color-accent', text: 'Color (Accent)' },
      { value: 'underline', text: 'Underline' },
      { value: 'underline-primary', text: 'Underline (Primary)' },
      { value: 'underline-secondary', text: 'Underline (Secondary)' },
      { value: 'underline-accent', text: 'Underline (Accent)' }
    ],
    required: true,
    hint: 'Select the styling for active menu items and hover.'
  }
}

export default {
  content,
  design,
  layout,
  advanced
}
